/* eslint-disable react/require-default-props */
import React from 'react';
import AiManagementCheckbox from 'components/atoms/ai_management_checkbox';
import { Card } from './styles';

interface AiManagementItemCardProps {
  id: string;
  label: string;
  meta: string[];
  title?: string;
  interested: boolean;
  selected: boolean;
  expanded: boolean;
  canExpand?: boolean;
  onToggleSelected: () => void;
  onToggleExpanded: () => void;
  onToggleInterest: () => void;
  children?: React.ReactNode;
}

const AiManagementItemCard: React.FC<AiManagementItemCardProps> = ({
  id,
  label,
  meta,
  title,
  interested,
  selected,
  expanded,
  canExpand = true,
  onToggleSelected,
  onToggleExpanded,
  onToggleInterest,
  children,
}) => {
  const checkboxId = `${id}-${label.replace(/\W+/g, '-')}`;

  return (
    <Card className="card border mb-3">
      <div className="card-body d-flex align-items-center p-4">
        <AiManagementCheckbox
          id={checkboxId}
          checked={selected}
          className="flex-shrink-0 mr-3"
          onChange={onToggleSelected}
        >
          <span className="sr-only">Selecionar {label}</span>
        </AiManagementCheckbox>

        <button
          type="button"
          className={`btn btn-star p-0 mr-3 flex-shrink-0 ${interested ? 'text-warning' : ''}`}
          onClick={onToggleInterest}
          aria-pressed={interested}
          title={interested ? 'Remover dos interesses' : 'Marcar como interesse'}
          aria-label={`${interested ? 'Remover' : 'Marcar'} interesse em ${label}`}
        >
          <i className="material-icons align-middle">{interested ? 'star' : 'star_border'}</i>
        </button>

        <div className="item-summary text-muted flex-grow-1 mr-3" title={title}>
          <span className="item-label font-weight-bold">{label}</span>
          {meta.map((text) => (
            <span key={text}>
              <span className="mx-2">•</span>
              {text}
            </span>
          ))}
        </div>

        <button
          type="button"
          className="btn btn-secondary btn-expand d-inline-flex align-items-center justify-content-center flex-shrink-0 p-0"
          onClick={onToggleExpanded}
          disabled={!canExpand}
          aria-expanded={expanded}
          aria-label={expanded ? `Recolher ${label}` : `Expandir ${label}`}
        >
          <i className="material-icons">{expanded ? 'expand_less' : 'expand_more'}</i>
        </button>
      </div>

      {expanded ? <div className="card-body px-4 pt-0 pb-4">{children}</div> : null}
    </Card>
  );
};

export default AiManagementItemCard;
